import clsx from 'clsx'
import React, { CSSProperties, ReactElement, useRef, useState } from 'react'
import { Controller } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import styles from './styles.module.scss'

import { IconSvg } from '../../atoms'

export interface IControllerTextFieldProps {
  control: any
  rules?: any
  name: any
  message?: string
  label?: string | ReactElement
  placeholder?: string
  unit?: string
  type?: any
  fullWidth?: boolean
  style?: CSSProperties
  formatValue?: (arg: any) => string | undefined
  inline?: boolean
  disabled?: boolean
  onReset?: () => void
  emptyAsNull?: true
}

const ControlledTextField = ({
  control,
  rules = {},
  name,
  message,
  label,
  placeholder = 'Écrire ici',
  unit,
  type,
  fullWidth,
  style = {},
  formatValue,
  inline = false,
  disabled = false,
  onReset,
  emptyAsNull,
}: IControllerTextFieldProps) => {
  const [isFocused, setIsFocused] = useState(false)

  const ref = useRef<any>()

  return (
    <div
      className={clsx(styles.field, {
        [styles.fullWidth]: fullWidth,
        [styles.inline]: inline,
        [styles.disabled]: disabled,
      })}
      style={style}
    >
      {label && <div className={styles.title}>{label}</div>}
      <div className={styles.valueContainer}>
        <Controller
          control={control}
          rules={rules}
          render={({ field, formState: { errors } }) => {
            const computedValue =
              field.value === '' ||
              field.value === null ||
              field.value === undefined
                ? emptyAsNull
                  ? ''
                  : ''
                : field.value

            return (
              <>
                <div
                  className={clsx(styles.containerInput, {
                    [styles.disabled]: disabled,
                  })}
                >
                  <input
                    className={styles.input}
                    value={computedValue}
                    onChange={field.onChange}
                    onBlur={() => {
                      setIsFocused(false)
                      field.onBlur()
                    }}
                    onClick={() => setIsFocused(true)}
                    placeholder={placeholder}
                    type={type}
                    onWheel={(e) => type === 'number' && e.currentTarget.blur()}
                    ref={ref}
                    size={1}
                    disabled={disabled}
                  />
                  {formatValue &&
                    field.value !== undefined &&
                    field.value !== null &&
                    !isFocused && (
                      <div
                        className={styles.formattedValue}
                        onClick={() => {
                          ref.current.focus()
                          setIsFocused(true)
                        }}
                      >
                        {formatValue(field.value)}
                      </div>
                    )}
                  {unit && <div className={styles.unit}>{unit}</div>}
                </div>
                {errors[name] && (
                  <span className={styles.error}>
                    {errors[name]?.message?.toString() || ''}
                  </span>
                )}
              </>
            )
          }}
          name={name}
        />
        {message && <span className={styles.error}>{message}</span>}
        {onReset && (
          <div
            className={clsx(styles.reset, { [styles.disabled]: disabled })}
            onClick={() => {
              if (!disabled) {
                onReset()
              }
            }}
          >
            <IconSvg.Reset />
            <span>
              <FormattedMessage
                defaultMessage='Réinitialiser'
                id='ui.ControlledTextField.reset'
              />
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default ControlledTextField
